import React from 'react';
import { II18n } from '../../../../../models';
import { I18nService } from '../../../../../services';

const translations: II18n = {
  es: {
    phone: 'Teléfono',
  },
  enUS: {
    phone: 'Phone',
  },
  ptBR: {
    phone: 'Telefone',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { translate };
